export default {
    help: 'Служба поддержки',
    options: {
        who_are_we: 'Кто мы такие?',
        what_is_bookeraj: 'Что такое Bookeraj?',
        how_you_can_improve: 'Как мы можем улучшить ваш бизнес?',
        companies: 'Компании',
        company_registration: 'Регистрация и настройка компании',
        company_users: 'Настройка пользователей компании',
        inactivity_setup: 'Настройка неактивности',
        users: 'Пользователи',
        user_profile_setup: 'Настройка профиля пользователя',
        offers: 'Услуги',
        create_offer: 'Создание услуги',
        offer_actions: 'Действия с услугами',
        finding_offer: 'Поиск услуг',
        chose: 'Пожалуйста, выберите из вариантов...',
        create_discount: 'Создать скидку',
    },
}
